import { createContext, useContext, useEffect, useMemo, useState } from "react";
import ar from "./ar";
import en from "./en";

const dictionaries = { ar, en };

const LanguageContext = createContext(null);

export function LanguageProvider({ children, defaultLang = "ar" }) {
  const [lang, setLang] = useState(defaultLang);

  const toggleLanguage = () => setLang((l) => (l === "ar" ? "en" : "ar"));

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => dictionaries[lang] || dictionaries.ar, [lang]);

  const value = useMemo(
    () => ({
      lang,
      toggleLanguage,
      t,
    }),
    [lang, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}

